import PropTypes from 'prop-types';
import { Modal } from 'react-bootstrap';

const CommonModal = ({ bodyClass, animation, modalSize, modalBody, handleShow, modalClass }) => {
  return (
    <Modal
      size={modalSize}
      aria-labelledby="contained-modal-title-vcenter"
      centered
      show={handleShow}
      animation={animation}
      className={modalClass}
    >
      <Modal.Body className={bodyClass}>{modalBody && modalBody}</Modal.Body>
    </Modal>
  );
};

CommonModal.propTypes = {
  modalSize: PropTypes.any,
  mainModalclass: PropTypes.any,
  modalBody: PropTypes.any,
  modalClass: PropTypes.any,
  modalTitle: PropTypes.any,
  handleShow: PropTypes.any,
  animation: PropTypes.any,
  headerClass: PropTypes.any,
  bodyClass: PropTypes.any,
};

export default CommonModal;